/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Tabs, Tab, MenuItem, FormControlLabel, Checkbox } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const Address = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45);
  const [content, setContent] = useState({
    shipping: { zip: "", town: "", street: "", intnum: "", state: "", locality: "", extnum: "", reference: "", country: "" },
    invoicing: { zip: "", town: "", street: "", intnum: "", state: "", locality: "", extnum: "", reference: "", country: "" },
  });
  const [tabActive, setTabActive] = useState("shipping");
  const [sameAddress, setSameAddress] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState("");
  const [locality, setLocality] = useState({
    shipping: [],
    invoicing: [],
  });
  const [catsShipping, setCatsShipping] = useState([]);
  const [catsInvoicing, setCatsInvoicing] = useState([]);
  useEffect(() => {
    init();
  }, [props.contentModal]);

  const init = async () => {
    props.changeLoader(true);
    setZPos(-1);
    let ad = content;
    for (let c in props.contentModal.countryCatalog) {
      if ( props.contentModal.countryCatalog[c].v === "Mexico" || props.contentModal.countryCatalog[c].v === "México") {
        setDefaultCountry(props.contentModal.countryCatalog[c].k);
        break;
      }
    }

    if (props.contentModal.address) {
      let address = props.contentModal.address;
      if (address.shipping) {
        if (address.shipping.country) {
          ad.shipping.country = address.shipping.country;
        }

        if (address.shipping.zip) {
          ad.shipping.zip = address.shipping.zip;
          findCatalogs("shipping", address.shipping.zip);
        }

        if (address.shipping.town) {
          ad.shipping.town = address.shipping.town;
        }

        if (address.shipping.street) {
          ad.shipping.street = address.shipping.street;
        }

        if (address.shipping.intnum) {
          ad.shipping.intnum = address.shipping.intnum;
        }

        if (address.shipping.state) {
          ad.shipping.state = address.shipping.state;
        }

        if (address.shipping.locality) {
          ad.shipping.locality = address.shipping.locality;
        }

        if (address.shipping.extnum) {
          ad.shipping.extnum = address.shipping.extnum;
        }

        if (address.shipping.reference) {
          ad.shipping.reference = address.shipping.reference;
        }
      }

      if (address.invoicing) {
        if (address.invoicing.country) {
          ad.invoicing.country = address.invoicing.country;
        }

        if (address.invoicing.zip) {
          ad.invoicing.zip = address.invoicing.zip;
        }

        if (address.invoicing.town) {
          ad.invoicing.town = address.invoicing.town;
        }

        if (address.invoicing.street) {
          ad.invoicing.street = address.invoicing.street;
        }

        if (address.invoicing.intnum) {
          ad.invoicing.intnum = address.invoicing.intnum;
        }

        if (address.invoicing.state) {
          ad.invoicing.state = address.invoicing.state;
        }

        if (address.invoicing.locality) {
          ad.invoicing.locality = address.invoicing.locality;
        }

        if (address.invoicing.extnum) {
          ad.invoicing.extnum = address.invoicing.extnum;
        }

        if (address.invoicing.reference) {
          ad.invoicing.reference = address.invoicing.reference;
        }
      }
    }
    props.changeLoader(false);
    setZPos(45);
  };

  const findCatalogs = async (type, zip) => {
    let cats = [];
    if (type == "shipping") {
      let req = await getCatalog("zip", zip);
      if (req.status == 200 && req.data.data.response == "OK") {
        let cat = req.data.data.catalog;
        for (let i = 0; i < cat.length; i++) {
          cats.push(cat[i]["m"][0].township);
        }
      }
      setCatsShipping(JSON.parse(JSON.stringify(cats)));
    }

    if (type == "invoicing") {
      let req = await getCatalog("zip", zip);
      if (req.status == 200 && req.data.data.response == "OK") {
        let cat = req.data.data.catalog;
        for (let i = 0; i < cat.length; i++) {
          cats.push(cat[i]["m"][0].township);
        }
      }
      setCatsInvoicing(JSON.parse(JSON.stringify(cats)));
    }
  };

  const searchLocality = async (zipShipping, zipInvoicing) => {
    let shippingCat = [];
    let invoicingCat = [];
    if (zipShipping) {
      let shipping = await getCatalog("zip", zipShipping);
      if (shipping.status == 200 && shipping.data.data.response == "OK") {
        let catShip = shipping.data.data.catalog;
        for (let i = 0; i < catShip.length; i++) {
          shippingCat.push(catShip[i]["m"][0].township);
        }
      }
    }
    if (zipInvoicing) {
      let invoicing = await getCatalog("zip", zipInvoicing);
      if (invoicing.status == 200 && invoicing.data.data.response == "OK") {
        let catInvo = invoicing.data.data.catalog;
        for (let i = 0; i < catInvo.length; i++) {
          invoicingCat.push(catInvo[i]["m"][0].township);
        }
      }
    }

    setLocality({
      shipping: shippingCat,
      invoicing: invoicingCat,
    });
  };

  const changeTab = async (index) => {
    setTabActive(index);
    findCatalogs(index, content[index]["zip"]);
  };

  const changeValue = async (address, field, type, e) => {
    let c = content;
    if (type == "integer") {
      if (!isNaN(e.target.value)) {
        c[address][field] = e.target.value;
      }
    }

    if (field == "zip") {
      if (c[address]["zip"].length == 5) {
        let zipCatalog = await getCatalog("zip", c[address]["zip"]);
        if (zipCatalog.status == 200 && zipCatalog.data.data.response == "OK") {
          let cat = [];
          for (let i = 0; i < zipCatalog.data.data.catalog.length; i++) {
            cat.push(zipCatalog.data.data.catalog[i]["m"][0].township);
          }
          if (address == "shipping") {
            setCatsShipping(JSON.parse(JSON.stringify(cat)));
          }
          if (address == "invoicing") {
            setCatsInvoicing(JSON.parse(JSON.stringify(cat)));
          }
          c[address]["state"] = zipCatalog.data.data.catalog[0]?.["m"]?.[0]?.state_key;
          c[address]["town"] = zipCatalog.data.data.catalog[0]?.["m"]?.[0]?.municipality;
        }
      }
      if (c[address]["zip"].length > 5) {
        c[address]["zip"] = c[address]["zip"].substring(0, 5);
      }
    }

    if (type == "text") {
      c[address][field] = e.target.value;
    }

    if (type == "select") {
      c[address][field] = e.target.value;
    }

    if (sameAddress && address == "shipping") {
      c["invoicing"] = c["shipping"];
    }

    setContent(JSON.parse(JSON.stringify(c)));
  };

  const getCatalog = async (name, zip) => {
    props.changeLoader(true);
    setZPos(-1);
    let data = {
      catalog: {
        id: name,
        filters: [
          {
            key: zip,
          },
        ],
      },
    };

    let catalog = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
    setZPos(45);
    return catalog;
  };

  const handleChange = (e) => {
    setSameAddress(e.target.checked);
    let c = content;
    c["invoicing"] = c["shipping"];
    setContent(JSON.parse(JSON.stringify(c)));
  };

  const update = async () => {
    props.changeLoader(true);
    setZPos(-1);
		let addresses =  {
			shipping: {
				zip: content["shipping"].zip,
				town: content["shipping"].town ? content["shipping"].town.trim() : '',
				street: content["shipping"].street ? content["shipping"].street.trim() : '',
				intnum: content["shipping"].intnum ? content["shipping"].intnum.trim() : '',
				state: content["shipping"].state ? content["shipping"].state.trim() : '',
				locality: content["shipping"].locality ? content["shipping"].locality.trim() : '',
				extnum: content["shipping"].extnum ? content["shipping"].extnum.trim() : '',
				reference: content["shipping"].reference ? content["shipping"].reference.trim() : ""
			},
			invoicing: {
				zip: content["invoicing"].zip,
				town: content["invoicing"].town ? content["invoicing"].town.trim() : '',
				street: content["invoicing"].street ? content["invoicing"].street.trim() : '',
				intnum: content["invoicing"].intnum ? content["invoicing"].intnum.trim() : '',
				state: content["invoicing"].state ? content["invoicing"].state.trim() : '',
				locality: content["invoicing"].locality ? content["invoicing"].locality.trim() : '',
				extnum: content["invoicing"].extnum ? content["invoicing"].extnum.trim() : '',
				reference: content["invoicing"].reference ? content["invoicing"].reference.trim() : ""
			}}

    if (sameAddress) {
      addresses.invoicing = addresses.shipping;
    }
    delete addresses.shipping["geoaddress"];
    delete addresses.invoicing["geoaddress"];
    let data = {
      customer: {
        uuid: props.contentModal["customer_uuid"],
        address: addresses,
      },
    };
    if (!addresses.shipping["country"]) {
      addresses.shipping["country"] = defaultCountry;
    }
    if (!addresses.invoicing["country"]) {
      addresses.invoicing["country"] = defaultCountry;
    }

    let updateAddress = await API.service( "updateAddress", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
    setZPos(45);

    if (updateAddress.status == 200) {
      if (updateAddress.data.data.response == "OK") {
        props.changeAlert(true, "success", "Datos actualizados con éxito");
        let newWidgets = [];
        for (let i = 0; i < props.contentModal.widgets.length; i++) {
          if (props.contentModal.widgets[i]["type"] == "address") {
            newWidgets.push(updateAddress.data.data.widget[0]);
          } else {
            newWidgets.push(props.contentModal.widgets[i]);
          }
        }
        props.contentModal.changeWidgets(newWidgets);
        closelightbox();
      } else {
      }
    } else {
    }
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(false)}>
				<DialogTitle >
					Editar Domicilio
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
					<Tabs value={0} >
						<Tab label="De envío" onClick={changeTab.bind(this, 'shipping')}  sx={{borderBottom: tabActive === "shipping" ? "#3743aa solid 2px" : ""}}/>
						<Tab label="De facturación" onClick={changeTab.bind(this, 'invoicing')}  sx={{borderBottom: tabActive === "invoicing" ? "#3743aa solid 2px" : ""}}/>
					</Tabs>
				</Box>
				
				<DialogContent>					
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						<Grid item xs={6}>
							<TextField
								label="Código Postal" value={content[tabActive].zip} onChange={changeValue.bind(this, tabActive, 'zip', 'integer')} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
              <TextField  
                label="Estado" value={content[tabActive].state} select size="small" fullWidth onChange={changeValue.bind(this, tabActive, 'state', 'select')} >
                {props.contentModal.stateCatalog?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
						<Grid item xs={6}>
							<TextField
								label="Alcaldia / Municipio" value={content[tabActive].town || ''} onChange={changeValue.bind(this, tabActive, 'town', 'text')} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
              <TextField  label="Colonia" value={(tabActive == 'shipping' && catsShipping.length > 0 ) ? content[tabActive].locality : (tabActive == 'invoicing' && catsInvoicing.length > 0 ) ? content[tabActive].locality : ''} select size="small" fullWidth onChange={changeValue.bind(this, tabActive, 'locality', 'select')} >
                { tabActive == 'shipping' && catsShipping?.map((item, index) => (
                  <MenuItem key={`shipping-${index}`} value={item}>{item}</MenuItem>
                ))}
								{ tabActive == 'invoicing' && catsInvoicing?.map((item, index) => (
                  <MenuItem key={`invoicing-${index}`} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </Grid>
						<Grid item xs={6}>
							<TextField
								label="Calle" value={content[tabActive].street} onChange={changeValue.bind(this, tabActive, 'street', 'text')} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="No. ext." value={content[tabActive].extnum} onChange={changeValue.bind(this, tabActive, 'extnum', 'text')} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="No. int." value={content[tabActive].intnum} onChange={changeValue.bind(this, tabActive, 'intnum', 'text')} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Referencias" value={content[tabActive].reference} onChange={changeValue.bind(this, tabActive, 'reference', 'text')} size="small" fullWidth />
						</Grid>
					</Grid>

					{tabActive == 'shipping' && 
						<Grid item xs={12} sx={{ marginTop: "16px"}}>
							<FormControlLabel control={<Checkbox checked={sameAddress} onChange={handleChange}/>} label={"Utilizar mismo domicilio en facturación"} />
						</Grid>					
					}

				</DialogContent>
				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button variant="contained" onClick={update.bind(this)}>Guardar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog> 
  );
};

export default Address;
